import classNames from 'classnames'

import styles from './StepBlocks.module.scss'

type Props = {
  steps: {
    className?: string
    node: React.ReactNode
  }[]
}

const StepBlocks = ({ steps }: Props) => (
  <div className={styles.stepBlocks}>
    {steps.map((step, i) => (
      <div
        className={classNames(
          styles.stepBlock,
          i === 0 ? styles.left : i === steps.length - 1 ? styles.right : styles.middle,
          step.className,
        )}
        key={i}
      >
        {step.node}
      </div>
    ))}
  </div>
)

export default StepBlocks
